<template>
  <div>
            <van-pull-refresh v-model="isLoading" @refresh="ekipgetir">
              <div v-for="item in ekip" :key="item.kid" >
                <van-swipe-cell>
                  <van-cell icon="user-circle-o" :title="item.isim" :value="item.tip"/>
                    <template v-if="ayar.yetki==='el'" #right>
                      <van-button square type="primary" text="Çıkart" @click="aktar(item.kid,item.isim,'0')"/>
                    </template>
                </van-swipe-cell>
              </div>

            <van-divider>Ekibi olmayan personel</van-divider>

              <div v-for="items in ekipsiz" :key="items.kid">
                <van-swipe-cell>
                  <van-cell icon="user-circle-o" :title="items.isim" :value="items.tip"/>
                    <template v-if="ayar.yetki==='el'" #right>
                      <van-button square type="danger" text="Ekibe Al" @click="aktar(items.kid,items.isim,ayar.ekipid)"/>
                    </template>
                </van-swipe-cell>
              </div>
            </van-pull-refresh>

          <div style="height:70px"></div>
         <van-tabbar v-model="active">
          <van-tabbar-item name="Home" to="/" icon="wap-home-o">Home</van-tabbar-item>
          <van-tabbar-item name="Servis" to="/servis" icon="todo-list-o">Servis</van-tabbar-item>
          <van-tabbar-item name="Sepet" to="/sepet" icon="cluster-o">Ekibim</van-tabbar-item>
          <van-tabbar-item name="Depom" to="/depo" icon="apps-o">Depom</van-tabbar-item>
          <van-tabbar-item name="Cihaz" to="/gruplama" icon="fire-o">Cihaz</van-tabbar-item>
          <van-tabbar-item name="Hesabım" to="/hesap" icon="user-o">Hesap</van-tabbar-item>
         </van-tabbar>
         <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
  </div>
</template>

<script>
import { Notify } from 'vant';
import { Dialog } from 'vant';
export default {
  data() {
    return {
      active:'Sepet',
      show:false,
      ekip:[],
      ayar:this.$request.ayar(),
      isLoading: false,
      ekipsiz:[]

    };
  },
  created(){
    this.show = true
    this.ekipgetir()
  },
  methods: {

        ekipgetir() {
            this.$request.get("servis/ekibim/"+this.ayar.firmaid+"/"+this.ayar.ekipid)
            .then(res => {
                this.ekip = res.results,
                this.ekipsizgetir()
            })
        },
        ekipsizgetir() {
          //this.show = true
            this.$request.get("servis/ekipsiz/"+this.ayar.firmaid+"/"+this.ayar.bid)
            .then(res => {
                this.ekipsiz  = res.results
                this.show = false;
                this.isLoading = false;
              })
        },
        aktar(id,name,durum){
  let mesaj1 = '';
  let mesaj2 = '';
switch(durum) {

  case '0':
      mesaj1 = "Ekipden Çıkarılacak ?";
      mesaj2 = "Personel Ekipden Çıkartıldı";
    break;

  default:
      mesaj1 = "Ekibe Alınacak ?";
      mesaj2 = "Personel Ekibe Alındı";
}
              Dialog.confirm({
                title: name,
                message: mesaj1,
              })
                .then(() => {
                    this.show = true
                    let newpost = {kid : id, ekibis:durum}
                    this.$request.post("cikart", newpost)
                   .then(res => {Notify({ type: 'success', message: mesaj2 })
                   this.ekipgetir()
                   })
                   .catch(err => { Notify({ type: 'danger', message: 'Hata...' });})
                })
                .catch(() => {Notify({ type: 'danger', message: 'İşlem iptal edildi' })});
        }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/sepet.vue